// The project detail page serves both of these from ONE component instance
// (vue-router reuses it when two records render the same component), so the
// edit session, its staged changes and its history survive moving between
// them. See sessionSurvivesNavigation in the detail page.
export const PROJECT_DETAIL_ROUTE_NAMES = new Set(['projects-detail', 'projects-detail-browse'])

export function isWithinProjectBrowseNavigation(to, from) {
  return to?.name === 'projects-detail-browse'
    && from?.name === 'projects-detail-browse'
    && String(to.params?.id ?? '') === String(from.params?.id ?? '')
}

export function projectBrowserItemRoute(projectId, itemId, currentQuery = {}, workspace = '') {
  const query = { ...currentQuery, item: String(itemId) }
  delete query.tab
  if (workspace) query.workspace = workspace
  else delete query.workspace
  return {
    name: 'projects-detail-browse',
    params: { id: String(projectId) },
    query,
  }
}

export function projectArtRoute(projectId, currentQuery = {}) {
  const query = { ...currentQuery }
  delete query.tab
  delete query.item
  delete query.workspace
  return {
    name: 'projects-detail',
    params: { id: String(projectId) },
    query,
  }
}

// Reordering a workspace-filtered board only returns that visible subset.
// Replace the subset's slots in the full project order without disturbing
// items hidden by the filter.
export function mergeFilteredItemOrder(allIds, filteredOrder) {
  const filtered = new Set(filteredOrder)
  let index = 0
  return allIds.map(id => filtered.has(id) ? filteredOrder[index++] : id)
}
